import React, {
  useState,
  setState,
  useEffect,
  useContext,
  useCallback,
} from "react";
import axios from "axios";
import { makeStyles } from "@material-ui/core/styles";

import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { Paper, Table, TableBody } from "@material-ui/core";
import Loader from "../common/loader/Loader";
import Sports from "../common/Sports";
import { set } from "lodash";

export default function Leagues(props) {
  //const user = useContext(UserContext);
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    title: {
      marginLeft: theme.spacing(2),
      flex: 1,
    },
    button: {
      margin: theme.spacing(1),
    },

    center: {
      margin: "0 auto",
      border: "1px grey black",
      textAlign: "center",
      width: "75%",
      "& .MuiTextField-root": {
        margin: theme.spacing(1),
        width: 200,
      },
      "& .MuiFormGroup-row": {
        justifyContent: "center",
      },
      "& .MuiFormControl-root": {
        justifyContent: "center",
      },
    },
  }));
  const classes = useStyles();

  const [leagues, setLeagues] = React.useState([]);
  const requestLeagues = useCallback(() => {
    // Change for server api address
    let url = process.env.REACT_APP_API2_URL + "/League/League_GetAllLeagues";
    axios({
      method: "get",
      url: url,
      /*  REPLACE WITH SELECT DATA */
    }).then((response) => {
      setLeagues(response.data);
    });
  }, []);

  useEffect(() => {
    requestLeagues();
  }, []);

  /* se quito el ,[] que se puede para no hacer tantos renders*/
  const options = {
    page: 1, // which page you want to show as default
    hideSizePerPage: true,
    sizePerPage: 15, // which size per page you want to locate as default
    pageStartIndex: 1, // where to start counting the pages
    paginationSize: 1, // the pagination bar size.
    prePage: "<", // Previous page button text
    nextPage: ">", // Next page button text
    firstPage: "First", // First page button text
    lastPage: "Last", // Last page button text
    paginationShowsTotal: true, // Accept bool or function // Accept bool or function
    paginationPosition: "bottom", // default is bottom, top and both is all available
    // hideSizePerPage: true > You can hide the dropdown for sizePerPage
    // alwaysShowAllBtns: true // Always show next and previous button
    onRowClick: selectedValues,
    withFirstAndLast: false, // > Hide the going to First and Last page button
  };

  function selectedValues(row) {
    console.log("props =====>", row.idLeague);
    props.ChangeLeagueID(row.idLeague);
    // alert(`You click row id: ${row.idLeague}`);
  }

  /*Select Functions*/

  /*const selectRowProp = {
    mode: 'checkbox',
  };*/
  /*End Select Functions*/

  const [dataBySport, setDataBySport] = useState([]);
  const [sport, setSport] = useState();
  const onSportChanged = useCallback((sport) => {
    setSport(sport);
  }, []);

  useEffect(() => {
    if (sport) {
      setDataBySport(leagues.filter((x) => x.idSport === sport));
    }
  }, [leagues, sport]);

  return (
    <div id="main-div profile-list" class="profile-list">
      <Paper className={`${classes.root} gap-4 flex flex-col`}>
        <Sports setIdSportOnMem={onSportChanged} />
        <Table className={classes.table} aria-label="simple table">
          <TableBody className="show-table">
            <BootstrapTable
              data={dataBySport}
              options={options}
              //selectRow={selectRowProp}
              pagination={true}
              version="4"
              hover
            >
              <TableHeaderColumn
                visible="none"
                isKey={true}
                hidden
                hiddenOnInsert
                autoValue={true}
                dataField="IdLeague"
              >
                ID
              </TableHeaderColumn>

              <TableHeaderColumn
                dataField="Description"
                filter={{ type: "TextFilter" }}
              >
                League
              </TableHeaderColumn>
            </BootstrapTable>
          </TableBody>
        </Table>
      </Paper>
    </div>
  );
}
